import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';

const clearFalsyValues = obj => {
    return pickBy(obj, identity);
};

export default clearFalsyValues;
